import MatchHeight from 'matchheight';
import {scrollSlidesA11y} from "../utils/swiperA11y";

export default class SliderCards {
    constructor() {
        this.mh = new MatchHeight();
        let sliders = document.querySelectorAll('.swiper-cards');


        sliders.forEach((slider) => {
            const block = slider.closest(".block");
            const prev = block.querySelector(".navigation-button-prev");
            const next = block.querySelector(".navigation-button-next");

            new Swiper(slider, {
                slidesPerView: "auto",
                spaceBetween: slider.dataset.spaceBetween ?? 0,
                grabCursor: true,
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },
                ...scrollSlidesA11y,
            });

            this.mh.update();
        });
    }
}
